/* @flow */
import React from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";

import withData from "../../withData";
import Gettext from "../../common/Gettext";
import Money from "../../Money";

import friendsCoin from "./images/friend-coins.png";
import friendsCoinMobile from "./images/friend-coins-mobile.png";

import Modal from "../Modal";

import type { DepositBonusInserted as Bonus } from "../../../redux/CommonTypes";

const Tooltip = styled.div`
  color: ${({theme}) => theme.foreground};
  background: ${({theme}) => theme.popupBackground};
  z-index: 2000;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  font-size: 0;

  :nth-child(1) {
    @media (max-width: 959px) {
      padding-right: 54px;
    }
  }

  :nth-child(2) {
    display: block;
    padding: 50px 55px 45px;
    text-align: center;
    background: ${({theme}) => theme.popupDarkBackground};
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }
`;

const FriendCoins = styled.img`
  display: inline-block;
  vertical-align: middle;

  @media (max-width: 959px) {
    display: none;
  }
`;

const FriendCoinsMobile = styled.img`
  display: none;
  vertical-align: middle;

  @media (max-width: 959px) {
    display: inline-block;
    width: 100px;
  }

  @media (max-width: 640px), (max-height: 500px) {
    width: 80px;
  }
`;

const Title = styled.div`
  direction: ${props => props.theme.direction};
  display: inline-block;
  vertical-align: middle;
  color: ${({theme}) => theme.foreground};
  font-size: 36px;
  font-weight: 600;
  line-height: 1;

  @media (max-width: 959px) {
    display: none;
  }

  @media (max-width: 850px) {
    max-width: 270px;
  }
`;

const TitleMobile = styled.div`
  direction: ${props => props.theme.direction};
  display: none;
  color: ${({theme}) => theme.foreground};
  align-items: center;
  flex-direction: column;
  font-weight: 600;
  font-size: 24px;
  line-height: 1;

  @media (max-width: 959px) {
    display: flex;
    flex: 1;
  }

  @media (max-width: 640px), (max-height: 500px) {
    font-size: 16px;
  }

  @media (max-width: 360px) {
    display: block;
    margin: 0 auto;
  }
`;

const Subtitle = styled.div`
  direction: ${props => props.theme.direction};
  color: ${({theme}) => theme.foreground};
  font-size: 18px;
  font-weight: 400;

  @media (max-width: 959px) {
    font-size: 28px;
  }

  @media (max-width: 640px), (max-height: 500px) {
    font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  }
`;

const Amount = styled.div`
  padding-left: 7px;
  font-weight: 600;
  font-size: 48px;
  color: #3B9478;

  @media (max-width: 959px) {
    color: #363636;
  }

  @media (max-width: 640px), (max-height: 500px) {
    font-size: 24px;
  }
`;

const Currency = styled(Money.Symbol)`
  top: -15px;
  padding-left: 10px;
  color: #717171;
  font-size: 24px;
  font-weight: 500;
  vertical-align: super;

  @media (max-width: 959px) {
    top: -10px;
    padding-left: 2px;
    font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
    color: #363636;
  }
`;

const Link = styled.div`
  margin-top: 20px;
  color: #3498db;
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }

  @media (max-width: 959px) {
    font-size: 32px;
    text-decoration: underline;

    :hover {
      text-decoration: none;
    }
  }

  @media (max-width: 640px), (max-height: 500px) {
    font-size: 16px;
    margin-top: 10px;
  }
`;

const domain =
  process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
    ? "IronTrade"
    : "SiamOption";

type Props = Bonus & {
  location: Object,
  history: Object,
  onDismiss: () => void
};

class ReferralBonusSlave extends React.Component<Props, {}> {
  handleRedirect = () => {
    this.props.onDismiss();
    if (this.props.location.match !== "profile") {
      this.props.history.push("/profile");
    }
  };

  render() {
    const { onDismiss, amount, apiConfigs: { refBonusMinDepo }, remoteTradeSettings: { currency } } = this.props;
    const minDeposit = refBonusMinDepo[currency];

    return (
      <Modal onDismiss={onDismiss}>
        <Tooltip>
          <Wrapper>
            <FriendCoins src={friendsCoin} />
            <FriendCoinsMobile src={friendsCoinMobile} />
            <Title>
              <Gettext>You received a bonus</Gettext>:
              <Amount>
                <Money Symbol={Currency}>{amount}</Money>
              </Amount>
            </Title>
            <TitleMobile>
              <Gettext>You received a bonus</Gettext>:{" "}
              <Money Symbol={Currency}>{amount}</Money>
            </TitleMobile>
          </Wrapper>
          <Wrapper>
            <Subtitle>
              <Gettext>
                For every friend who signs up using your link and makes a one-time deposit of
              </Gettext>
              {" "}
              <Money>{minDeposit}</Money>
              {" "}
              <Gettext>
                or more in seven days after the registration date, you get
              </Gettext>:
              <br />
              <br />
              <strong>
                <Money>{amount}</Money>
              </strong>
            </Subtitle>
            <Link onClick={this.handleRedirect}>
              <Gettext>Invite more friends to {domain}</Gettext>
            </Link>
          </Wrapper>
        </Tooltip>
      </Modal>
    );
  }
}

export default withData(["apiConfigs", "remoteTradeSettings"])(withRouter(ReferralBonusSlave));



// WEBPACK FOOTER //
// ./src/components/TradeModals/ReferralBonus/ReferralBonusSlave.js